import { render } from "./order_hybrid_wholesale_view.vue?vue&type=template&id=2dd318f9&scoped=true"
import script from "./order_hybrid_wholesale_view.vue?vue&type=script&lang=js"
export * from "./order_hybrid_wholesale_view.vue?vue&type=script&lang=js"

import "./order_hybrid_wholesale_view.vue?vue&type=style&index=0&id=2dd318f9&scoped=true&lang=css"
import "./order_hybrid_wholesale_view.vue?vue&type=style&index=1&id=2dd318f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd318f9"]])

export default __exports__